// extracted by mini-css-extract-plugin
export var container = "_um-0";
export var table = "_um-2";
export var tableWrapper = "_um-1";